import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    TimelineSection,
    TimelineItem,
    ActivityIcon,
    ActivityContent,
    ActivityMeta,
    UserInfo,
    SectionTitle,
    UserLink,
} from '../../styles/CardModal.styles';
import { Button } from '../../styles/Modal.styles';

const BoardActivity = ({ boardActivities, cardActivities, projectMembers }) => {
    const [showCardActivities, setShowCardActivities] = useState(true);

    const allActivities = showCardActivities
        ? [...boardActivities, ...cardActivities]
        : boardActivities;

    if (allActivities.length === 0) {
        return <div>No board activity yet.</div>;
    }

    // Sort activities by timestamp in descending order
    const sortedActivities = [...allActivities].sort((a, b) => {
        const dateA = a.timestamp?.seconds ? new Date(a.timestamp.seconds * 1000) : new Date(a.timestamp);
        const dateB = b.timestamp?.seconds ? new Date(b.timestamp.seconds * 1000) : new Date(b.timestamp);
        return dateB - dateA;
    });

    return (
        <TimelineSection>
            <SectionTitle>Board Activity</SectionTitle>
            <Button onClick={() => setShowCardActivities(!showCardActivities)}>
                {showCardActivities ? 'Hide Card Activities' : 'Show Card Activities'}
            </Button>
            {sortedActivities.map(item => (
                <TimelineItem key={item.id}>
                    <UserLink to={`/profile/${item.userId}`}>
                        <ActivityIcon>
                            {projectMembers && projectMembers[item.userId] && projectMembers[item.userId].photoURL ? (
                                <img
                                    src={projectMembers[item.userId].photoURL}
                                    alt=""
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '50%'
                                    }}
                                />
                            ) : (
                                <span>{item.userName?.[0] || '•'}</span>
                            )}
                        </ActivityIcon>
                    </UserLink>
                    <ActivityContent>
                        <UserInfo>
                            <div dangerouslySetInnerHTML={{ __html: `<a href="/profile/${item.userId}">${item.userName}</a> ${item.action}` }} />
                            {item.cardName && (
                                <small> on card: <Link to={`/card/${item.cardId}`}>{item.cardName}</Link></small>
                            )}
                        </UserInfo>
                        <ActivityMeta>
                            {item.timestamp?.seconds ? new Date(item.timestamp.seconds * 1000).toLocaleString() : new Date(item.timestamp).toLocaleString()}
                        </ActivityMeta>
                    </ActivityContent>
                </TimelineItem>
            ))}
        </TimelineSection>
    );
};

export default BoardActivity;
